import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "text-body-1 text-black font-weight-bold mb-2" }

import { injectStrict, AxiosKey, SnackbarKey } from '@/symbols';
import { useRouter } from 'vue-router';
import { AxiosResponse } from 'axios';
import { ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PaymentConfirmationPage',
  props: {
    confirmationNumber: { type: String, required: true },
    token: { type: String, required: true }
},
  setup(__props) {

/* global Server */
const http = injectStrict(AxiosKey);
const Snackbar = injectStrict(SnackbarKey);
const router = useRouter();

//eslint-disable-next-line
const props = __props

function downloadReceipt() {

    if (props.confirmationNumber && props.token) {
        const form: Server.IPaymentReceiptReportParams = {
            ConfirmationNumber: props.confirmationNumber || '',
            Token: props.token || ''
        };

        http.post(`Payment/DownloadPaymentReceiptReport`, form, {
            responseType: "blob",
        })
            .then((response: any) => {
                const blob = new Blob([response.data], { type: 'application/pdf' });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = `${props.confirmationNumber}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(link.href);
                Snackbar.open("Receipt has been downloaded.", 5000, 'green');
            })
            .catch(() => {
                Snackbar.open("An error occurred while downloading your receipt. Please try again later.", 5000, 'error');
            });
    } else {
        Snackbar.open("An error occurred while downloading your receipt. Please try again later.", 5000, 'error');
    }
}


const hasAttachments = ref(false);
const attachmentMessage = ref('');

function getPaymentInformation() {
    if (props.confirmationNumber && props.token) {
        const form: Server.IPaymentReceiptReportParams = {
            ConfirmationNumber: props.confirmationNumber || '',
            Token: props.token || ''
        };
        http.post('Payment/GetPaymentConfirmation', form)
            .then((response: AxiosResponse<Server.IPaymentConfirmation>) => {
                if (response.status == 200) {
                    hasAttachments.value = response.data.HasAttachments;
                    attachmentMessage.value = response.data.AtachmentMessage;
                }
            })
    } 
}

getPaymentInformation();

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "py-6" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "elevation-2" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, { class: "text-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        size: "80px",
                        color: "success",
                        icon: "mdi-check-circle-outline"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { class: "justify-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "6",
                    xs: "3"
                  }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createElementVNode("div", { class: "text-h3 font-weight-bold mb-2 text-blue-grey-darken-4" }, "Payment successful", -1),
                      _createElementVNode("div", { class: "text-body-1 text-black font-weight-bold mb-2" }, " A receipt has been sent to your email. ", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (hasAttachments.value)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 0,
                    class: "justify-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "6",
                        xs: "3"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_1, _toDisplayString(attachmentMessage.value), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        variant: "outlined",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (downloadReceipt()))
                      }, {
                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                          _createElementVNode("b", null, "Download Receipt", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        variant: "text",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push('/')))
                      }, {
                        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                          _createTextVNode("Return to Home", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})